// This optional code is used to register a service worker.
// register() is not called by default.

let isWaitingForServiceWorkerControl = false
let hasReloadedForServiceWorkerUpdate = false
let isListeningForControllerChange = false

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

export function register (config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
    if (publicUrl.origin !== window.location.origin) {
      return
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config)
        navigator.serviceWorker.ready.then(() => {
          console.log('This web app is being served cache-first by a service worker.')
        })
      } else {
        registerValidSW(swUrl, config)
      }
    })
  }
}

function reloadWhenUpdatedServiceWorkerTakesControl () {
  if (isListeningForControllerChange || !navigator.serviceWorker.addEventListener) {
    return
  }

  isListeningForControllerChange = true
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!isWaitingForServiceWorkerControl || hasReloadedForServiceWorkerUpdate) {
      return
    }

    hasReloadedForServiceWorkerUpdate = true
    window.location.reload()
  })
}

function activateUpdatedServiceWorker (registration) {
  const waitingWorker = registration.waiting
  if (!waitingWorker) {
    return
  }

  isWaitingForServiceWorkerControl = true
  reloadWhenUpdatedServiceWorkerTakesControl()
  waitingWorker.postMessage({ type: 'SKIP_WAITING' })
}

function registerValidSW (swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      if (navigator.serviceWorker.controller) {
        activateUpdatedServiceWorker(registration)
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        if (installingWorker == null) {
          return
        }
        if (navigator.serviceWorker.controller) {
          isWaitingForServiceWorkerControl = true
          reloadWhenUpdatedServiceWorkerTakesControl()
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New content is available; refreshing to use it.')
              activateUpdatedServiceWorker(registration)
              if (config && config.onUpdate) {
                config.onUpdate(registration)
              }
            } else {
              console.log('Content is cached for offline use.')
              if (config && config.onSuccess) {
                config.onSuccess(registration)
              }
            }
          }
        }
      }
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error)
    })
}

function checkValidServiceWorker (swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type')
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload()
          })
        })
      } else {
        registerValidSW(swUrl, config)
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.')
    })
}

export function unregister () {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister()
      })
      .catch((error) => {
        console.error(error.message)
      })
  }
}
